/**
 * @public
 */
export type FlexContainerDirection = 'horizontal' | 'vertical';

/**
 * @public
 */
export type FlexContainerAlign = 'start' | 'end' | 'center' | 'stretch';

/**
 * @public
 */
export type FlexContainerJustify =
    | 'start'
    | 'end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
